import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import SearchIcon from '@material-ui/icons/Search'
import useNearestCoaches from '@hooks/useNearestCoaches'
import CoachCardVersion3 from '@components/coach-card-version-3'
import useStyles from './coaches-search-section.styles'

const CoachesSearchSection = (props) => {
  const {
    title,
    description,
    cta,
    coachCardClass,
  } = props
  const styles = useStyles()

  const coachesToShow = 2
  const { nearestCoaches } = useNearestCoaches(coachesToShow)

  const CtaButton = () => (
    <Button
      variant="outlined"
      color="secondary"
      className={styles.linkButton}
      href="/coaches/search"
      fullWidth
      startIcon={<SearchIcon />}
    >
      {cta}
    </Button>
  )

  return (
    <Box className={styles.root} paddingX={2}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {description}
      </Typography>
      {
        nearestCoaches.map((hit) => {
          return (
            <Box key={hit.objectID} marginY={1}>
              <CoachCardVersion3 hit={hit} coachCardClass={coachCardClass} />
            </Box>
          )
        })
      }
      <Box mt={[3]}>
        <CtaButton />
      </Box>
    </Box>
  )
}

CoachesSearchSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.string,
  coachCardClass: PropTypes.string,
}

export default CoachesSearchSection
